export const permissions = [
  {
    permission: 'Approve and Manage Access',
    id: '0',
    order: 0,
    isPaa: true,
    isActive: true,
    code: 'AMA',
  },
  {
    permission: 'Eligibility and Benefits Checks',
    id: '1',
    order: 1,
    isPaa: false,
    isActive: true,
    code: 'EBC',
  },
  {
    permission: 'Provider, Practice and Facility Management',
    id: '2',
    order: 2,
    isPaa: false,
    isActive: true,
    code: 'PPF',
  },
  {
    permission: 'Reporting',
    code: 'R',
    subPermissions: [
      {
        name: 'Hospital Performance Based Compensation',
        code: 'R',
        subCode: 'HPBC',
        description:
          'Provides an incentive to hospitals for quality and efficiency improvements in the delivery of health care affecting the overall health of UnitedHealthcare commercial members and cost of health care.',
      },
      {
        name: 'UnitedHealthcare West Capitation Reports',
        code: 'R',
        subCode: 'UWCR',
        description:
          'Reports provided support capitation payment calculation. These reports provide current and retroactive transactions at the summary level and at the member detail level.',
      },
      {
        name: 'Report Center',
        code: 'R',
        subCode: 'UR',
        description:
          'Includes Capitation Claim Recovery, Early Preventive Screenings Diagnostic Testing (EPSDT) for Medicaid, Hospital Monitoring, PCP Panel Roster, Preventive Health Measures and Stars Scoreboard.',
      },
      {
        name: 'UnitedHealthcare West Eligibility Reports',
        code: 'R',
        subCode: 'UWER',
        description:
          'Includes Eligibility Data files (EL915), Member Cost Share (EL918) and Maximum Out of Pocket (EL917) reports.',
      },
      {
        name: 'UnitedHealthcare Insights',
        code: 'R',
        subCode: 'UI',
        description:
          'UnitedHealthcare Insights delivers key performance metrics in a solution that is easy to navigate, understand and take action.',
      },
    ],
    id: '3',
    order: 100,
    isPaa: true,
    isActive: true,
  },
  {
    permission: 'Claims and Payment Management',
    id: '4',
    order: 4,
    isPaa: false,
    isActive: true,
    code: 'CPM',
  },
  {
    permission: 'Prior Authorizations and Referrals',
    id: '5',
    order: 5,
    isPaa: false,
    isActive: true,
    code: 'PAR',
  },
];
